<template>
  <div class="center-item" @click="click">
    <slot name="left">
      <span>{{ title }}</span>
    </slot>
    <div class="center-item-right">
      <slot name="right">
        <img class="right" src="../assets/images/right.svg" alt />
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
.center-item {
  padding: 18px 6.4%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  position: relative;
  .avatar {
    display: flex;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    // margin-right: 12px;
    position: relative;
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 64px !important;
      height: 64px !important;
      border-radius: 50px;
      z-index: 9;
      padding-left: 0;
      opacity: 0;
      cursor: pointer;
    }
    .avatars {
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      z-index: 1;
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 6.4%;
    width: 87.6vw;
    height: 1px;
    background: #f2f2f7;
    z-index: 9;
  }
  span {
    font-size: 17px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
  }
  .center-item-right {
    display: flex;
    align-items: center;
    span {
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      line-height: 22px;
      display: inline-block;
      margin-right: 12px;
    }
    /deep/ .el-select {
      width: 75px;
      margin-right: 12px;
    }
    .right {
      width: 10px;
      height: 16px;
    }
  }
}
</style>
